
(function () {
	document.addEventListener("DOMContentLoaded", () => {

		if (!document.querySelector(".vg-map")) return;
		if (!document.querySelector(".vg-gymlist")) return;

		document.addEventListener("click", (event) => {

			const item = event.target;

			if (!item) return;

			if (handleGymListSelection(item)) return;
		});

		document.addEventListener("gtmGymSearchEvent", (event) => {

			const { searchQuery, selection } = event.detail;

			VgGtm.pushRegisterEventToDataLayer(
				'search',
				{},
				{ 
					event_category: 'buscador_gimnasios',
					event_detail: 'busqueda_manual',
					event_label: searchQuery,
					club_name: selection.api === 'store' ? selection.description : 'sin_seleccionar',
				}
			);
		});

		document.addEventListener("vgMapGymClick", async (event) => {
			if (!event.detail) return;

			const gym = event.detail;

			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{ 
					event_category: 'mapa',
					event_detail: 'chincheta',
					event_label: VgGtm.formatGtmLabel(gym.properties.name),
					club_name: VgGtm.formatGtmLabel(gym.properties.name),
				}
			);
		});

		document.addEventListener("selectedGym", async (event) => {
			if (!event.detail) return;
			
			const gym = event.detail;

			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{ 
					event_category: 'mapa',
					event_detail: 'tarjeta_gimnasio',
					event_label: 'inscribirme',
					club_name: VgGtm.formatGtmLabel(gym.name),
				}
			);
		});

		document.addEventListener("viewDetailGym", async (event) => {
			if (!event.detail) return;
			
			const gym = event.detail;
			
			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{ 
					event_category: 'mapa',
					event_detail: 'tarjeta_gimnasio',
					event_label: 'ver_mas',
					club_name: VgGtm.formatGtmLabel(gym.name),
				}
			);
		});

		function handleGymListSelection(item) {
			if (!item || !item.classList.contains("gymlist__gym")) return false;

			const countrySelect = document.querySelector("#vg-country");
			const selectedCountry = countrySelect?.options[countrySelect.selectedIndex].text.toLowerCase();

			const province = item.getAttribute("data-gym-province");
			const region = item.getAttribute("data-gym-region");

			const clubRegion = province ? province : region;
			const clubName = item.textContent.trim();

			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{ 
					event_category: 'listado_completo',
					event_detail: selectedCountry,
					event_label: VgGtm.formatGtmLabel(clubRegion + '_' + clubName),
					club_name: VgGtm.formatGtmLabel(clubName),
					club_region: VgGtm.formatGtmLabel(clubRegion),
				}
			);

			return true;
		}
	});
})();